import { useState } from 'react'
import { useUsersApiClient } from '@/api/users/useUsersApiClient.ts'
import { useDownloadExcelFile } from '@/presentation/common/hooks/crud/v2/useDownloadExcelFile.ts'

export const useDownloadUsersExcel = () => {
  const repository = useUsersApiClient()
  const query = useDownloadExcelFile<void>({
    filename : 'users.xlsx',
    callable : repository.downloadExcelResume,
    messages : {
      default : 'Error al generar archivo',
      loading : 'Generando archivo',
      success : 'Archivo generado',
    },
  })

  const [ data, setData ] = useState<File>()

  const submit = async () => {
    const response = await query.submit()
    setData(response)
  }

  return {
    ...query,
    submit,
    data,
  }
}
